import {h, Fragment} from "preact"
export default () => {
    return (
        <div
            class="ns-loader-wrapper ns-d-flex ns-justify-content-center ns-align-items-center"
            style="z-index: 1; min-height: 70vh;"
        >
            <div class="ns-loader"></div>
        </div>
    )
}
